import { IconFileDocument16, IconActionClose16, IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatFileLoader.css';

type TChatFileLoader = {
  src: string | null;
  isOutcoming: boolean;
  isLoading?: boolean;
  withCancel?: boolean;
  withSave?: boolean;
  withReload?: boolean;
  withFileIcon?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  onReload?: () => void;
};

export const ChatFileLoader: React.FC<TChatFileLoader> = ({
  src,
  isOutcoming,
  isLoading,
  withCancel,
  withSave,
  withReload,
  withFileIcon,
  onCancel,
  onSave,
  onReload,
}) => {
  return (
    <div className={styles['container']} data-name="ChatFileLoader">
      <div
        className={classNames(styles['circle'], isLoading && styles['loader'], !isOutcoming && styles['incoming'])}
      />
      {withCancel && onCancel && (
        <button className={styles['button']} onClick={onCancel}>
          <IconActionClose16 color={isOutcoming ? 'icon-main-default' : 'icon-inverted-default'} />
        </button>
      )}
      {withSave && src && (
        <a href={src} className={styles['button']} onClick={onSave} target="_blank" data-name="ChatFileLoader_save">
          <IconFileDocument16 color={isOutcoming ? 'icon-main-default' : 'icon-inverted-default'} />
        </a>
      )}
      {withReload && onReload && (
        <button className={styles['button']} onClick={onReload}>
          <IconActionReload16 color={isOutcoming ? 'icon-main-default' : 'icon-inverted-default'} />
        </button>
      )}
      {withFileIcon && !withSave && (
        <div className={styles['button']}>
          <IconFileDocument16 color={isOutcoming ? 'icon-main-default' : 'icon-inverted-default'} />
        </div>
      )}
    </div>
  );
};
